import { AggregatedUserWidget } from '@markant-platform/widgets/model';

export const MOCKED_WIDGETS: AggregatedUserWidget[] = [
  {
    displayName: 'My external widget 1',
    widgetComponent: {
      type: 'EXTERNAL',
    },
  },
  {
    displayName: 'My external widget 2',
    widgetComponent: {
      type: 'EXTERNAL',
    },
  },
  {
    displayName: 'My external widget 3',
    widgetComponent: {
      type: 'EXTERNAL',
    },
  },
  {
    displayName: 'My internal widget 1',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
  {
    displayName: 'My internal widget 2',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
  {
    displayName: 'My internal widget 3',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
] as AggregatedUserWidget[];

export const MOCKED_EXTERNAL_WIDGETS: AggregatedUserWidget[] = [
  {
    displayName: 'My external widget 1',
    widgetComponent: {
      type: 'EXTERNAL',
    },
  },
  {
    displayName: 'My external widget 2',
    widgetComponent: {
      type: 'EXTERNAL',
    },
  },
  {
    displayName: 'My external widget 3',
    widgetComponent: {
      type: 'EXTERNAL',
    },
  },
] as AggregatedUserWidget[];

export const MOCKED_INTERNAL_WIDGETS: AggregatedUserWidget[] = [
  {
    displayName: 'My internal widget 1',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
  {
    displayName: 'My internal widget 2',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
  {
    displayName: 'My internal widget 3',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
] as AggregatedUserWidget[];

export const MOCKED_WIDGETS_WITH_TARGET_PAGES: AggregatedUserWidget[] = [
  {
    displayName: 'My Widget 1',
    widgetComponent: {
      type: 'EXTERNAL',
    },
    widgetEntrypoint: 'http://localhost:4300/remoteEntry.js',
    targetPage: {
      openOn: 'PLATFORM',
      routePath: 'myExternalService',
      exposedPath: './ExternalServiceModule',
      componentName: 'MyExternalServiceComponent',
    },
  },
  {
    displayName: 'My Widget 2',
    widgetComponent: {
      type: 'EXTERNAL',
    },
    widgetEntrypoint: 'http://localhost:4300/remoteEntry.js',
    targetPage: {
      openOn: 'EXTERNAL_LINK',
      externalLink: 'https://someUrl/my-service',
    },
  },
  {
    displayName: 'My Widget 3',
    widgetComponent: {
      type: 'EXTERNAL',
    },
    widgetEntrypoint: 'http://localhost:4300/remoteEntry.js',
    targetPage: {
      openOn: 'PLATFORM',
      routePath: 'someOtherExternalService',
      exposedPath: './DashboardModule',
      componentName: 'DashboardComponent',
    },
  },
  {
    displayName: 'My Widget 4',
    widgetComponent: {
      type: 'INTERNAL',
    },
  },
] as AggregatedUserWidget[];
